// @ts-nocheck
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import constants from "@store/constants";
import { addToChainAfter, createChainHandler } from "@toolkit/Modules/client-framework/HandlerCreator";

export const AfterPopulateApiParameter = createChainHandler("AfterPopulateApiParameter", chain, props => {
    const state = props.getState();
    const pageType = getCurrentPage(state).type;

    if (pageType !== constants.pageType.checkoutReviewAndSubmit && pageType !== constants.pageType.orderConfirmation) {
        props.apiParameter.expand = props.apiParameter.expand?.filter(
            x => !["tax", "shipping", "carriers"].includes(x),
        );
    }
});

addToChainAfter(chain, PopulateApiParameter, AfterPopulateApiParameter);
